import _ from 'lodash';

// generates unique id for tile
const getTileId = text => _.uniqueId(text);

// creates basic tile object
const getCollectionTile = (text, props = {}) => ({
  id: getTileId(text),
  renderId: getTileId(text),
  text,
  // true for all empty tiles in tray collection
  // empty tile appears in tray collection once original tile was moved to desk from tray
  movedToDesk: false,
  ...props,
});

// creates basic object of tile placed on desk
const getDeskTile = (tile, deskOrder, props = {}) => ({
  ...tile,
  ...props,
  deskOrder,
  movedToDesk: false,
});

// returns same any tiles collection, but with new render ids
// and if desk collection, adds proper order indexes
const getRegeneratedRenderIdCollection = deskCollection =>
  deskCollection.map((tile, deskOrder) => ({
    ...tile,
    renderId: getTileId(tile.text),
    deskOrder,
  }));

// returns same tray tiles collection, but distributed between left and right trays
const getTrayDistributedCollection = (trayCollection) => {
  const cutBorder = Math.round(trayCollection.length / 2);

  return trayCollection.map((tile, index) => {
    // first half goes to left, second - to right
    const trayProps = index < cutBorder ? { left: true } : { right: true };
    return {
      ...tile,
      ...trayProps,
    };
  });
};

// calculates collection weight: sum of lengths of all tiles
const getCollectionWeight = collection => collection.reduce((weight, tile) => weight + tile.text.length, 0);

// calculates which tray (left or right) should new tile be added to
const getEasiestTrayProp = (collection) => {
  const [leftCollection, rightCollection] = _.partition(
    _.reject(collection, tile => tile.movedToDesk),
    tile => tile.left,
  );

  return getCollectionWeight(leftCollection) > getCollectionWeight(rightCollection) ? { right: true } : { left: true };
};

const isCutTileSolutionTile = (targetWord, cutTileText, isPowerPlates) => {
  const targetTiles = isPowerPlates ?
    [targetWord.slice(0, targetWord.length - 3), targetWord.slice(targetWord.length - 3)] : targetWord.split('');
  const cutTiles = isPowerPlates ? [cutTileText] : cutTileText.split('');

  return _.intersection(targetTiles, cutTiles).length > 0;
};

export default {
  getTileId,
  getCollectionTile,
  getDeskTile,
  getRegeneratedRenderIdCollection,
  getTrayDistributedCollection,
  getCollectionWeight,
  getEasiestTrayProp,
  isCutTileSolutionTile,
};
